const HEADING_LEVELS = {
  H1: 'h1',
  H2: 'h2',
  H3: 'h3',
  H4: 'h4',
  H5: 'h5',
  H6: 'h6',
  LABEL: 'label'
};
const HEADING_VARIANTS = {
  ALPHA: 'alpha',
  BETA: 'beta',
  GAMMA: 'gamma',
  DELTA: 'delta',
  EPSILON: 'epsilon',
  ZETA: 'zeta'
};

export { HEADING_LEVELS, HEADING_VARIANTS };
